module.exports = __webpack_public_path__ + "img/essentials@2x.7633a70.webp";